<template>
<div>
  <h4 style="padding: 20px;">
    Scan Tags Continuously Using Phone App
  </h4>
  <p><v-btn color="blue" @click="requestScan">Scan Using Mobile App</v-btn></p>
  <p>{{code}}</p>
</div>
</template>

<script>
import UtilsMixins from '@/components/workflows/UtilsMixin.js'
import axiosInstances from '@/../../coreui/server/axiosInstances' // remove
export default {
  data: () => ({
    code: null
  }),
  mixins: [
    UtilsMixins
  ],
  methods: {
    callBack(tag) {
      // when a tag is scanned, this callback function is called
      console.log(tag)
      this.code = tag
    },
    // remove
    getRandom() {
      let num =  Math.floor(Math.random() * 5) / 100;
      if (num > 0.025) return num - 0.05;
      return num;
    },
    async post_update(plant, weight, strain_name) {
      plant['msync'] = 'no'
      plant['wet'] = {qty: weight, unit: "lb"}
      plant['IsHarvest'] = 'yes'
      plant['phase'] = 'Full Harvest'
      plant['harvested'] = "2022-05-03T18:22:46.444Z"
      plant['harvestName'] = strain_name + " 5/03/2022 - 1"
      await axiosInstances.apiServer.patch('dt/v1/cul_plants/' + plant['_id'], plant)
      console.log(plant)
    }
  },
  async mounted () {
    console.log('Initializing BC Scanner')
    // send callback function to call when a scan is received
    this.initBCScanner(this.callBack)
    return

    // temporarily used for some other tests
    let weights = []
    let strain_name =  'White Runtz' // 'Banana Cream Cake Jealousy' // 
    let total_weight =   376.88 // 14.1 //
    let res = await axiosInstances.apiServer.get('/dt/v1/set_strain?name=' + strain_name)
    if (res.data == null || res.data.length != 1) {
      console.log('no such strain or multiple strains')
      return
    }
    let strain = res.data[0]['_id']
    res = await axiosInstances.apiServer.get('/dt/v1/cul_plants?strain='+strain)
    if (res.data == null) { 
      console.log(`No plants of strain ${strain_name} found`)
      return 
    }
    let plants = res.data
    console.log(`Found ${plants.length} plants`)
    let average_weight = total_weight / plants.length
    average_weight = parseFloat(average_weight.toFixed(2)) // limit to two decimal and re-parse to avoid rounding errors
    console.log('average weight = ' , average_weight)
    let remaining_weight = total_weight // track reamining weights after each weight allocation, to be used towards end

    // first allocate weights, adjusted slightly by random number
    // hold back a few to adjust for rounding errors
    for (let i = 0; i < plants.length - 20; i++) {
      let cur_weight = parseFloat((average_weight + this.getRandom()).toFixed(2))
      remaining_weight = parseFloat((remaining_weight - cur_weight).toFixed(2));
      console.log(i, cur_weight, remaining_weight)
      weights.push(cur_weight)
    }

    // now just allocate remaining by avergae weight, but hold back one to adjust for rounding
    average_weight = remaining_weight / 20;
    console.log('remaining weight, average_weight = ', remaining_weight, average_weight)
    for (let i = plants.length - 20; i < plants.length -1 ; i++) {
      let cur_weight = parseFloat(average_weight.toFixed(2))
      remaining_weight = parseFloat((remaining_weight - cur_weight).toFixed(2));
      console.log(i, cur_weight, remaining_weight)
      weights.push(cur_weight)
    }

    // allocate the final remaining weight to the last plant
    weights.push(remaining_weight)

    // final check to add up all the allocated weights and compare to total_weight
    let computed_total = 0
    for (let i = 0; i < weights.length; i++) {
      console.log(i, weights[i])
      computed_total += weights[i]
      await this.post_update(plants[i], weights[i], strain_name) // post the weight to plants
    }
    console.log(`computed_total = ${computed_total}, original total = ${total_weight}`)
    // end test, remove afterwards
  },
  destroyed () {
    // this.endBCScanner() // enable later
  }
}
</script>

